export default __webpack_public_path__ + "671f4547937256906eeb529f074cad41.gif";